import React from "react";

// Official IADA - Anáhuac Business School logo asset
const LOGO_SRC = "/iada-anahuac-logo.jpg";
const ALT = "IADA - Instituto de Alta Dirección · Anáhuac Business School · Aliado académico";

const SIZE_MAP = {
  sm: "h-8",
  md: "h-14",
  lg: "h-24",
};

export default function IadaBadge({ size = "md", className = "" }) {
  const h = SIZE_MAP[size] || SIZE_MAP.md;
  return (
    <img
      src={LOGO_SRC}
      alt={ALT}
      aria-label={ALT}
      className={`${h} w-auto object-contain ${className}`}
      data-testid="iada-badge"
      loading="lazy"
    />
  );
}
